import * as Sentry from "@sentry/vue"
import { App } from "vue"

const registerSentry = (app: App) => {
  const dsn = window.runtimeEnv.VUE_APP_SENTRY_DSN

  if (dsn && String(dsn).length) {
    Sentry.init({
      app,
      dsn,
      tracesSampleRate: 0
    })
  }
}

export { registerSentry }
